<template>
<div class='project-card' :class="{'hover': hover}" v-on:mouseover='hover = true' v-on:mouseout='hover = false'>
  <div class='cover-wrapper'>
    <div class='mask'></div>
    <div class='status' :class="{'expired': state === 'expired', 'temp': state === 'temp', 'completed': state === 'completed'}">{{$t(`project.state.${state}`)}}</div>

    <div class='img cover' :style="{backgroundImage: 'url('+ project.thumbnail_url +')'}" v-if="project.thumbnail_url"></div>
    <div class='img cover default' v-else></div>
  </div>

  <div class='hover-actions-group'>
    <div class='qrcode' :class="{'show': qrcode}">
      <div class='img' :style="{backgroundImage: 'url('+ '//qrcode.ppj.io/' + project.viewer_url +')'}"></div>
    </div>

    <div class='actions'>
      <div class='action' :class="{'disabled': !available}">
        <a class='block-btn' :href="project.viewer_url" target="_blank" v-if="available">
          <div class='icon'><i class='ppj-icon-eye'></i></div>
          <p class='label'>{{$t('common.buttons.check')}}</p>
        </a>
        <a class='block-btn' v-else>
          <div class='icon'><i class='ppj-icon-eye'></i></div>
          <p class='label'>{{$t(`project.state.${state}`)}}</p>
        </a>
      </div>
      <router-link :to="`/projects/${project.id}`" tag='div' class='action' v-show="!readonly">
        <div class='icon'><i class='ppj-icon-pencil'></i></div>
        <p>{{$t('common.buttons.edit')}}</p>
      </router-link>
      <div class='action' v-show="!readonly">
        <a class='block-btn' @click="alterSource">
          <div class='icon'><i class='ppj-icon-arrows-cw'></i></div>
          <p>{{$t('actions.project.updatePPT')}}</p>
        </a>
      </div>
    </div>

    <el-button :plain="true" class='upgrade' @click="upgrade" v-show="!readonly" v-if="!project.permanent && !tbcMode">
      <i class='ppj-icon-star' style="margin-right:0.4em;"></i>升级永久
    </el-button>

    <el-button :plain="true" class='publicity' @click="togglePublicity" v-if="tbcMode && project.tbc && state === 'completed'">
      <i :class="`ppj-icon-${publicity ? 'lock-open-alt' : 'lock'}`" style="margin-right:0.4em;"></i>{{publicity ? '公开': '内部'}}
    </el-button>

    <el-dropdown class='move-to' menu-align='start' @command='moveTo' v-show="!readonly" v-if="!tbcMode">
      <span class="el-dropdown-link">{{$t('actions.project.moveTo')}}<i class="ppj-icon-down-dir"></i></span>
      <el-dropdown-menu class='dropdown-wrapper' slot="dropdown">
        <div v-on:mouseover='hover = true' v-on:mouseout='hover = false'>
          <el-dropdown-item command='all'>
            <div class='item'>{{$t('actions.category.all')}}</div>
          </el-dropdown-item>
          <el-dropdown-item v-for="(cat, index) in categories" :key='cat.id' :command="`${cat.id}`">
            <div class='item'>{{cat.name}}</div>
          </el-dropdown-item>
          <el-dropdown-item divided command='new'>
            <div class='item'><i class="ppj-icon-plus"></i>{{$t('actions.category.new')}}</div>
          </el-dropdown-item>
        </div>
      </el-dropdown-menu>
    </el-dropdown>
  </div>

  <div class='bottom-actions-group'>
    <el-row>
      <el-col :span="organization && !tbcMode ? 20 : 24">
        <p class='title' :class="{ 'tbc': tbcMode }">{{project.name}}<span class='nickname'>{{project.user.nickname}}</span></p>
      </el-col>
      <el-col :span="4" v-if="organization && !tbcMode">
        <div class='avatar-wrapper'>
          <el-tooltip class="item" effect="dark" :content="project.user.nickname" placement="left" :popper-options="{removeOnDestroy: true}" :open-delay="200">
            <div class='img avatar' :style="{backgroundImage: 'url('+project.user.profile_picture+')'}" />
          </el-tooltip>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <span class='sub-title'><i class='ppj-icon-clock'></i>{{dateReadable(project.created_at, true)}}</span>
      <span class='sub-title right'><i class='ppj-icon-eye'></i>{{project.pv}}</span>
    </el-row>
    <el-row>
      <div class='left'>
        <div class='btn qrcode' v-on:mouseover='qrcode = true' v-on:mouseout='qrcode = false' v-if="project.state === 'completed'"><i class='ppj-icon-qrcode'></i></div>
      </div>
      <div class='right'>
        <el-tooltip effect="dark" content="数据统计" placement="left" :popper-options="{removeOnDestroy: true}">
          <!--  -->
          <div class='btn'>
            <router-link :to="`/projects/${project.id}/stats`" tag='i' class='ppj-icon-chart-bar'>
            </router-link>
          </div>
        </el-tooltip>

        <el-dropdown class='btn' menu-align='start' v-show="!readonly">
          <span class="el-dropdown-link">
                <i class='ppj-icon-ellipsis-vert'></i>
            </span>
          <el-dropdown-menu class='small' slot="dropdown">
            <div v-on:mouseover='hover = true' v-on:mouseout='hover = false'>
              <el-dropdown-item>
                <div class='item' @click='rename'>
                  <i class="ppj-icon-pencil"></i>{{$t('common.buttons.rename')}}
                </div>
              </el-dropdown-item>
              <el-dropdown-item>
                <div class='item' @click='setThumbnail'>
                  <i class="ppj-icon-file-image"></i>{{$t('actions.project.alterCover')}}
                </div>
              </el-dropdown-item>
              <el-dropdown-item>
                <div class='item' @click='destroy'>
                  <i class="ppj-icon-trash"></i>{{$t('common.buttons.delete')}}
                </div>
              </el-dropdown-item>
            </div>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </el-row>
  </div>
</div>
</template>

<i18n>
{
  "zh-cn": {
    "deleteProjectCompleted": "@:common.project成功删除"
  }
}
</i18n>

<script>
import Vue from 'vue'
import Regex from '@/config/regexes'

export default {
  data() {
    return {
      qrcode: false,
      hover: false
    }
  },
  props: ['project'],
  computed: {
    state() {
      if (this.project.state !== 'completed') {
        return this.project.state
      }

      if (this.project.expired_at_in_ts && this.project.expired_at_in_ts < Date.now() / 1000) {
        return 'expired'
      }

      if (!this.project.permanent) {
        return 'temp'
      }

      return this.project.state
    },
    available() {
      return this.project.state === 'completed'
    },
    readonly() {
      return this.project.permissions.readonly
    },
    categories() {
      return this.$store.state.category.items
    },
    publicity() {
      return this.project.tbc ? this.project.tbc.public : null
    }
  },
  methods: {
    moveTo(command) {
      let vm = this
      let id = this.project.id
      let catId = command
      let success = function(res) {
        vm.$emit('refresh')
      }

      if (catId === 'new') {
        // need open category dialog to create first, then move to
        vm.$editCategory({
          success: function(catId) {
            vm.$store.dispatch('project/update', {
              id: id,
              category_id: catId
            }).then(success)
          }
        })
      } else {
        vm.$store.dispatch('project/update', {
          id: id,
          category_id: catId === 'all' ? null : Number(catId)
        }).then(success)
      }
    },
    togglePublicity() {
      let vm = this
      if (vm.publicity === null) return

      vm.$store.dispatch('project/update', {
        id: vm.project.id,
        tbc: { public: !vm.publicity }
      }).then(res => {
        vm.$message(`您的${vm.$t('common.project')}"${vm.project.name}"已设置成${res.data.tbc.public ? '公开' : '内部'}访问`)
        vm.$emit('update', res.data)
      })
    },
    alterSource() {
      let vm = this
      if (!vm.project.permissions.change_source) {
        let expired = vm.state === 'expired'
        let description = expired ? vm.$t('projectOverdateHint') : vm.$t('projectLockedHint')
        /* beautify preserve:start */
        this.$confirm((<p>{description}<a class='text-btn' href='/price' target='_blank'>了解详情</a></p>, description), '无法操作', {
          cancelButtonClass: 'el-button--text',
          confirmButtonText: expired ? vm.$t('upgradeProject') : vm.$t('unlockProject')
        }).then(() => {
          this.upgrade(expired ? 'upgrade' : 'unlock')
        })
         /* beautify preserve:end */
        return
      }
      vm.$router.push({
        name: 'project_upload',
        params: {
          id: this.project.id
        }
      })
    },
    upgrade(operator) {
      if (typeof operator !== 'string') {
        operator = undefined
      }
      let vm = this
      vm.$upgradeProject({
        projectId: vm.project.id,
        logoEnabled: vm.project.permissions.change_logo,
        operator: operator || 'upgrade',
        success: function() {
          vm.$parent.refreshData()
        }
      })
    },
    destroy() {
      let vm = this
      let id = vm.project.id

      let hintMessage = '<p>该操作将使生成的二维码和网址无法再继续访问，是否继续？</p>'

      vm.$confirm(new Vue().$createElement(Vue.compile(hintMessage)), vm.$t('messagebox.project.delete.title', {
        name: vm.project.name
      }), {
        cancelButtonClass: 'el-button--text',
        confirmButtonClass: 'el-button--danger',
        cancelButtonText: vm.$t('common.buttons.cancel'),
        confirmButtonText: '删除'
      }).then(_ => {
        vm.$store.dispatch('project/destroy', id).then(_ => {
          // 发送消息
          vm.$message({
            message: vm.$t('deleteProjectCompleted'),
            type: 'success'
          })
          vm.$emit('update', null)
        })
      }).catch(_ => {})
    },
    rename(project) {
      let vm = this
      let id = vm.project.id

      vm.$prompt(' ', vm.$t('messagebox.project.rename.title'), {
        cancelButtonClass: 'el-button--text',
        cancelButtonText: vm.$t('common.buttons.cancel'),
        confirmButtonText: vm.$t('common.buttons.save'),
        inputPattern: Regex.projectName,     // 匹配任何只要包含一个字符的字符串  .不能匹配空格
        inputErrorMessage: vm.$t('messagebox.project.rename.inputError'),
        inputValue: vm.project.name
      }).then(res => {
        vm.$store.dispatch('project/update', {
          id: id,
          name: res.value
        }).then(res => {
          vm.$emit('update', res.data)
        }).catch(err => {
          let data = err.response.data
          if (data.type === 'RecordInvalidError') {
            // 命名过长
            vm.$message({
              message: data.errors[0].details.map(d => d.message).join(','),
              type: 'error'
            })
          }
        })
      }).catch(_ => {})
    },
    setThumbnail(project) {
      let vm = this
      let id = vm.project.id
      vm.$mediaImage({
        initTag: 'thumbnail',
        success: function({ id: mediaId }) {
          vm.$store.dispatch('project/update', {
            id: id,
            thumbnail: mediaId
          }).then(res => {
            vm.$emit('update', res.data)
          })
        }
      })
    }
  }
}
</script>

<i18n>
{
  "zh-cn": {
    "projectOverdateHint": "@:common.project已过期，暂时无法更新PPT文件。升级为永久@:common.project可解除限制。",
    "projectLockedHint": "@:common.project被锁定，暂时无法更新PPT文件。使用永久@:common.project额度可以解除限制。",
    "upgradeProject": "升级@:common.project",
    "unlockProject": "解锁@:common.project"
  }
}
</i18n>

<style lang='scss'>
$name-height: 50px;

$bottom-actions-group-row-height: 30px;

.project-card {
    overflow: hidden;
    width: 100%;
    height: 100%;
    box-shadow: $box-shadow-base;
    position: relative;

    .cover-wrapper {
        display: block;
        position: absolute;
        width: 100%;
        top: 0;
        bottom: 2 * $bottom-actions-group-row-height + 2 * $padding-base;
        z-index: 1;
        text-align: center;
        margin: 0 auto;
        overflow: hidden;

        .status {
            background: $color-primary;
            color: $color-white-base;
            padding: 0.4em;
            line-height: 1;
            transform: translate(-50%, -0.7em) translate(1.5em, 1.5em) rotate(-45deg);
            position: absolute;
            width: 100%;
            right: 0;
            top: 0;
            font-size: $font-size-small;
            box-shadow: 0 1px 0 0 rgba(0,0,0,.12);

            &.expired {
                background: $color-gray-base;
            }

            &.temp {
                color: $color-black-base;
                background: #ffe200;
            }

            &.completed {
                display: none;
            }
        }

        .mask {
            display: block;
            position: absolute;
            width: 100%;
            height: 100%;
            z-index: 2;
            transition: $all-transition;
            background: rgba(0,0,0,0);
        }

        .img {
            &.default {
                background-image: url("~@/assets/images/project-sample-cover.jpg");
            }
        }
    }

    .hover-actions-group {
        transition: $all-transition;
        opacity: 0;
        width: 100%;
        z-index: 2;
        position: absolute;
        top: 0;
        bottom: 3 * $bottom-actions-group-row-height + 2 * $padding-base;

        .qrcode {
            position: relative;
            text-align: center;
            width: 100%;
            height: 100%;
            z-index: 4;
            background-color: #fff;
            border-bottom: $border-base;
            transform-origin: bottom left;
            transition: $all-transition;
            transform: scale(0);
            &.show {
                transform: scale(1);
            }
            .img {
                width: 80%;
                background-size: contain;
            }
        }

        .actions {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            display: table;
            width: 100%;
            z-index: 3;
        }

        .action {
            display: table-cell;
            cursor: pointer;
            width: 30%;

            .icon {
                width: 2.5em;
                height: 2.5em;
                border-radius: 2.5em;
                margin: 0 auto;
                background-color: $color-white-25-transparency;
                i {
                    width: 100%;
                    height: 100%;
                    display: block;
                    position: relative;
                    font-size: 1.2em;
                    text-align: center;
                    color: $color-white-75-transparency;
                    &:before {
                        line-height: 2.2em;
                    }
                }
            }

            p {
                text-align: center;
                white-space: nowrap;
                font-size: $font-size-small;
                color: $color-white-75-transparency;

                &.status {
                    display: none;
                }
            }
            &:not(.disabled):hover {
                p {
                    color: $color-white-base;
                }

                .icon {
                    background-color: $color-primary;
                    i {
                        color: $color-white-base;
                    }
                }
            }
            &.disabled {
                a {
                    cursor: not-allowed;
                }
            }
        }

        .publicity,
        .upgrade {
            position: absolute;
            top: 0;
            left: 0;
            background: transparent;
            border: none;
            font-size: $font-size-small;
            color: $color-white-75-transparency;
            display: block;
            padding: $padding-base;
            cursor: pointer;
            &:focus,
            &:hover {
                color: $color-white-base;
                background: transparent;
            }
        }

        .move-to {
            display: block;
            position: absolute;
            top: 0;
            right: 0;

            .el-dropdown-link {
                font-size: $font-size-small;
                color: $color-white-75-transparency;
                display: block;
                padding: 10px;
                cursor: pointer;
                &:hover {
                    color: $color-white-base;
                }
            }
        }
    }

    .bottom-actions-group {
        position: absolute;
        bottom: 0;
        padding: 0;
        background: $color-white-base;
        width: 100%;
        overflow: hidden;
        z-index: 2;
        border-top: $border-base;
        transition: $all-transition;
        transform: translateY($bottom-actions-group-row-height);
        padding: $padding-base;

        &:after {
            content: " ";
            position: absolute;
            width: 100%;
            height: $padding-base;
            background-color: $color-white-base;
            z-index: 3;
            top: $padding-base + 2 * $bottom-actions-group-row-height;
            left: 0;
        }

        // .row {
        //     position: relative;
        //     height: $name-height;
        //     padding: 0.2 * $name-height;
        //     width: 100%;
        // }
        .avatar-wrapper {
            width: 30px;
            height: 30px;
            float: right;
            .avatar {
                width: 80%;
                height: 80%;
                margin-top: 10%;
                border-radius: 50%;
                margin-right: 0;
            }
        }
        .title {
            color: $font-color-strong;
            text-align: center;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            line-height: 30px;
            margin: 0;
            .nickname {
              display: none;
            }
            &.tbc {
              text-align:left;
              padding-right: 5em;
              .nickname {
                display:block;
                position:absolute;
                right:0;
                top:0;
                max-width: 5em;
                font-size: 0.8em;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }
        }
        .sub-title {
            color: $font-color-base;
            text-align: left;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            line-height: 30px;
            margin: 0;

            & > i {
                margin-right: 0.5em;
            }
        }
        .btn {
            width: 0.6 * $name-height;
            height: 0.6 * $name-height;
            line-height: 0.6 * $name-height;
            margin-right: 3px;
            cursor: pointer;
            float: left;
            text-align: center;
            &:last-of-type {
                margin-right: 0;
            }
            i {
                line-height: normal;
                vertical-align: middle;
                font-size: 1.5em;
                color: #b2b2b2;

            }
            &.qrcode {
                background-color: #f7f7f7;

                i {
                    color: #555;
                }
            }
        }
    }

    &.hover {
        .cover-wrapper {
            .mask {
                background: rgba(0,0,0,0.7);
            }
        }
        .hover-actions-group {
            opacity: 1;
        }
        .bottom-actions-group {
            transform: translateY(0px);

            &:after {
                display: none;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// index.vue?93ef7c9e